import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Alert,
  CircularProgress,
  IconButton,
  InputAdornment,
  Snackbar,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Layout from '../components/Layout';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const Profile = () => {
  const { user, fetchUser } = useAuth();
  const [formData, setFormData] = useState({
    username: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [copySuccess, setCopySuccess] = useState(false);

  useEffect(() => {
    if (user) {
      setFormData({
        username: user.username || user.telegram_first_name || '',
      });
    }
  }, [user]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      const response = await axios.put('/api/users/me', formData);
      setSuccess('Профиль успешно обновлен');
      await fetchUser(); // Обновляем данные пользователя в контексте
    } catch (err) {
      setError(err.response?.data?.error || 'Ошибка обновления профиля');
    } finally {
      setLoading(false);
    }
  };

  const handleCopyUuid = () => {
    if (user?.uuid) {
      navigator.clipboard.writeText(user.uuid);
      setCopySuccess(true);
    }
  };

  return (
    <Layout>
      <Container maxWidth="md">
        <Box sx={{ mt: 4, mb: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            Профиль
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
              {success}
            </Alert>
          )}

          <Card>
            <CardContent>
              <form onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  label="Имя"
                  value={formData.username}
                  onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                  margin="normal"
                  required
                  placeholder={user?.telegram_first_name ? `Из Telegram: ${user.telegram_first_name}` : ''}
                  helperText={user?.telegram_first_name ? `Имя из Telegram: ${user.telegram_first_name}` : 'Имя из Telegram не указано'}
                />

                {user?.uuid && (
                  <Box sx={{ mt: 3, mb: 2 }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                      Вы можете поделиться с вашим идентификатором чтобы вас добавили в проект
                    </Typography>
                    <TextField
                      fullWidth
                      label="Ваш идентификатор (UUID)"
                      value={user.uuid}
                      margin="normal"
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={handleCopyUuid}
                              edge="end"
                              aria-label="Копировать UUID"
                            >
                              <ContentCopyIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                )}

                <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                  >
                    {loading ? <CircularProgress size={24} /> : 'Сохранить'}
                  </Button>
                </Box>
              </form>
            </CardContent>
          </Card>

          <Snackbar
            open={copySuccess}
            autoHideDuration={3000}
            onClose={() => setCopySuccess(false)}
            message="UUID скопирован в буфер обмена"
          />
        </Box>
      </Container>
    </Layout>
  );
};

export default Profile;
